import React, { forwardRef } from 'react';
import { ReactComponent as SvgImage } from '../assets/circuit.svg';

const AnimatedSVG = forwardRef((props, ref) => {
  return (
    <div className="svg-container" ref={ref}>
      <SvgImage />
    </div>
  );
});

export default AnimatedSVG;
